import { sendRequestJson } from '@/utils'

export class VoucherRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	/**
	 * Creates a new voucher set
	 * @param {Object} data - The voucher set data
	 * @param {string} data.name - Name of the voucher set
	 * @param {string} data.description - Description of the voucher set
	 * @param {string} data.date - Date for the voucher set
	 * @param {number} data.quantity - Quantity of vouchers to generate
	 * @param {string} data.label - Label to print on each voucher
	 * @param {boolean} data.printLabel - Whether to print the label on vouchers
	 * @returns {Promise<Object>} - Response from the API
	 */
	async createVoucherSet(data) {
		const url = this.urlBase + '/world/api/voucher-set'
		try {
			return await sendRequestJson({ data, url, method: 'POST' })
		} catch (e) {
			console.log('Error creating voucher set:', e)
			throw e
		}
	}
}

export const voucherRepository = new VoucherRepository()
